module.exports = __webpack_public_path__ + "img/IMG_5908.9743347c.jpg";